/** @lint */

/**
 * @module orb/features/_istatstracking
 */
define('orb/features/_istatstracking', ['orb/lib/_$'], function ($) {
    'use strict';

    /**
     Adds the default iStats tracking to Barlesque ORB.
     */
    return function () {
        require(['istats-1'], function (istats) {
            $.ready(function () {
                //  Set up tracking for masthead and footer links.
                istats.track('internal', {
                    region: $('.orb-nav-blocks')[0],
                    linkLocation: 'blq-mast-home-orbit'
                });
                istats.track('internal', {
                    region: $('#orb-nav-links'),
                    linkLocation: 'blq-nav-main-orbit'
                });
                istats.track('internal', {
                    region: $('#orb-aside'),
                    linkLocation: 'blq-foot-orbit'
                });
                istats.track('internal', {
                    region: $('#orb-footer'),
                    linkLocation: 'blq-foot-orbit'
                });
                istats.track('external', {
                    region: $('body')[0]
                });
                istats.track('download', {
                    region: $('body')[0]
                });
                $('.orb-nav-blocks')[0].linktrack = {'nav_link': 'Homepage'};
            });
        });
    };
});
